import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");
  return _openBlock(), _createBlock(_component_el_table_column, _mergeProps({
    type: "selection",
    width: "44px"
  }, _ctx.$attrs, {
    selectable: _ctx.selectable
  }), null, 16, ["selectable"]);
}